import aashto from './Aashto/Config';
import astm from './Astm/Config';

export default {
  ...aashto,
  ...astm,
};
